(function () {
  function getVideo(card) {
    return card && card.querySelector('.new-home-ugc-card__video');
  }

  function getSlide(card) {
    return card && card.closest('.new-home-ugc__slide');
  }

  function getCardIndex(card) {
    var slide = getSlide(card);
    return slide ? Number(slide.dataset.ugcIndex) : -1;
  }

  function updateAudioControl(card) {
    var video = getVideo(card);
    var control = card && card.querySelector('.new-home-ugc-card__audio');
    if (!video || !control) return;

    var action = video.muted ? 'Unmute' : 'Mute';
    card.classList.toggle('is-muted', video.muted);
    control.setAttribute('aria-label', action + ' video');
    control.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
    control.innerHTML = video.muted
      ? '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>'
      : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>';
  }

  function setMuted(card, muted) {
    var video = getVideo(card);
    if (!video) return;

    video.muted = muted;
    video.defaultMuted = muted;
    video.volume = muted ? 0 : 1;
    if (muted) video.setAttribute('muted', '');
    else video.removeAttribute('muted');

    updateAudioControl(card);
  }

  function pauseCard(card) {
    var video = getVideo(card);
    if (!video) return;
    video.pause();
    card.classList.remove('is-playing');
  }

  function pauseOtherCards(section, currentCard) {
    section.querySelectorAll('.new-home-ugc-card').forEach(function (card) {
      if (card !== currentCard) pauseCard(card);
    });
  }

  function playCard(section, card, allowMutedFallback) {
    var video = getVideo(card);
    if (!video) return;

    pauseOtherCards(section, card);
    setMuted(card, section.ugcMuted);
    if (video.ended) video.currentTime = 0;

    function attemptPlay(canFallbackToMuted) {
      var playPromise = video.play();
      if (!playPromise || typeof playPromise.then !== 'function') {
        card.classList.add('is-playing');
        return;
      }

      playPromise.then(function () {
        card.classList.add('is-playing');
      }).catch(function () {
        if (canFallbackToMuted && !video.muted) {
          section.ugcMuted = true;
          setMuted(card, true);
          attemptPlay(false);
          return;
        }
        card.classList.remove('is-playing');
      });
    }

    attemptPlay(allowMutedFallback !== false);
  }

  function bindPlayback(section) {
    var cards = Array.from(section.querySelectorAll('.new-home-ugc-card'));
    var track = section.querySelector('.new-home-ugc__track');

    cards.forEach(function (card, index) {
      if (card.dataset.playbackBound === 'true') return;
      card.dataset.playbackBound = 'true';

      var video = getVideo(card);
      var playButton = card.querySelector('.new-home-ugc-card__play');
      var audioButton = card.querySelector('.new-home-ugc-card__audio');
      if (!video || !playButton || !audioButton) return;

      playButton.addEventListener('click', function () {
        playCard(section, card);
      });

      video.addEventListener('click', function () {
        if (video.paused) {
          playCard(section, card);
        } else {
          pauseCard(card);
        }
      });

      audioButton.addEventListener('click', function (event) {
        event.stopPropagation();
        section.ugcMuted = !video.muted;
        setMuted(card, section.ugcMuted);
      });

      video.addEventListener('volumechange', function () {
        updateAudioControl(card);
      });

      video.addEventListener('pause', function () {
        card.classList.remove('is-playing');
      });

      video.addEventListener('ended', function () {
        card.classList.remove('is-playing');
        video.currentTime = 0;

        // Auto-advance to next video when ended
        var nextIndex = (index + 1) % cards.length;
        var nextCard = cards[nextIndex];
        if (nextCard && track) {
          var slide = getSlide(nextCard);
          if (slide) {
            var scrollPos = slide.offsetLeft - track.offsetLeft;
            track.scrollTo({ left: scrollPos, behavior: 'smooth' });
          }
          playCard(section, nextCard);
        }
      });

      setMuted(card, section.ugcMuted);
    });
  }

  function bindNavigation(section) {
    var track = section.querySelector('.new-home-ugc__track');
    var previous = section.querySelector('.new-home-ugc__arrow--previous');
    var next = section.querySelector('.new-home-ugc__arrow--next');
    if (!track) return;

    function getStep() {
      var slide = section.querySelector('.new-home-ugc__slide');
      if (!slide) return 240;
      var gap = 20;
      try {
        var style = window.getComputedStyle(track);
        gap = parseFloat(style.gap || style.columnGap) || 20;
      } catch (e) {}
      return slide.offsetWidth + gap;
    }

    if (previous) {
      previous.addEventListener('click', function () {
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        if (track.scrollLeft <= 8) {
          track.scrollTo({ left: maxScroll, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -getStep(), behavior: 'smooth' });
        }
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        if (track.scrollLeft >= maxScroll - 8) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: getStep(), behavior: 'smooth' });
        }
      });
    }
  }

  function observeSection(section) {
    if (typeof window.IntersectionObserver === 'undefined') return;

    section.ugcObserver = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          section.querySelectorAll('.new-home-ugc-card').forEach(pauseCard);
        }
      });
    }, { threshold: 0.1 });

    section.ugcObserver.observe(section);
  }

  function initSection(section) {
    if (!section || section.dataset.ugcInitialized === 'true') return;
    section.dataset.ugcInitialized = 'true';
    section.ugcMuted = false;

    bindPlayback(section);
    bindNavigation(section);
    observeSection(section);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-new-home-ugc]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('[data-new-home-ugc]');
    if (!section) return;
    if (section.ugcObserver) section.ugcObserver.disconnect();
    section.querySelectorAll('.new-home-ugc-card').forEach(pauseCard);
  });
})();
